const Quote = (props) => {
  const { quote } = props;

  return ( <p>{quote}</p> );
}
 
export default Quote;




